import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiltersStateNFF } from "./type";

const initialState: FiltersStateNFF = {
  fromDate: null,
  toDate: null,
};

const filtersSliceNFF = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<Date | null>) {
      state.toDate = action.payload;
    },
  },
});

export const { setFromDate, setToDate } = filtersSliceNFF.actions;

export default filtersSliceNFF.reducer;
